import { render, staticRenderFns } from "./order-select-modal.vue?vue&type=template&id=86350fd2&"
import script from "./order-select-modal.vue?vue&type=script&lang=js&"
export * from "./order-select-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports